import type { Component } from "svelte";
import type { DefineComponentOptions } from "../types.ts";

/**
 *
 *
 *
 *
 *
 */
export const createObservedAttributes = (
  props: DefineComponentOptions<Component>["props"],
): string[] => Object.entries(props).map(([key, { attribute }]) => (attribute ? attribute : key));
